/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  CHANGE_EMAIL_BANNER_ERROR_HEADING: 'changeEmail.bannerError.heading',
  CHANGE_EMAIL_BANNER_ERROR_LINK_LABEL: 'changeEmail.bannerError.link.label',
  CHANGE_EMAIL_FORM_LOAN_NUMBER_LABEL: 'changeEmail.form.loanNumber.label',
  CHANGE_EMAIL_SERVICE_ERROR_HEADING: 'changeEmail.serviceError.heading',
  CHANGE_EMAIL_SERVICE_ERROR_LINK_LABEL: 'changeEmail.serviceError.link.label',
  CHANGE_EMAIL_STEP_ONE_FORM_HEADING: 'changeEmail.stepOne.form.heading',
  CHANGE_EMAIL_STEP_ONE_FORM_PARAGRAPH: 'changeEmail.stepOne.form.parapgraph',
  CHANGE_EMAIL_STEP_TWO_FORM_HEADING: 'changeEmail.stepTwo.form.heading',
  CHANGE_EMAIL_STEP_TWO_FORM_PARAGRAPH: 'changeEmail.stepTwo.form.parapgraph',
  CHANGE_EMAIL_SUCCESS_HEADING: 'changeEmail.success.heading',
  CHANGE_EMAIL_SUCCESS_LINK_LABEL: 'changeEmail.success.link.label',
};

const enMessages = {
  [IDS.CHANGE_EMAIL_BANNER_ERROR_HEADING]: 'We are unable to register your loan at this time',
  [IDS.CHANGE_EMAIL_BANNER_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.CHANGE_EMAIL_FORM_LOAN_NUMBER_LABEL]: 'Loan number',
  [IDS.CHANGE_EMAIL_SERVICE_ERROR_HEADING]: 'Change Email - Error',
  [IDS.CHANGE_EMAIL_SERVICE_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.CHANGE_EMAIL_STEP_ONE_FORM_HEADING]: 'To update your email address, verify your loan information first',
  [IDS.CHANGE_EMAIL_STEP_ONE_FORM_PARAGRAPH]: 'Your 10-digit loan number can be found on mortgage statements and other loan-related documents.',
  [IDS.CHANGE_EMAIL_STEP_TWO_FORM_HEADING]: 'Please enter a new email address',
  [IDS.CHANGE_EMAIL_STEP_TWO_FORM_PARAGRAPH]: 'Your email address will be used if we need to contact you for any reason.',
  [IDS.CHANGE_EMAIL_SUCCESS_HEADING]: 'Success!\nYour email has been updated',
  [IDS.CHANGE_EMAIL_SUCCESS_LINK_LABEL]: 'Return to Login',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.CHANGE_EMAIL_BANNER_ERROR_HEADING]: 'We are unable to register your Murabaha Financing Transaction at this time',
  [IDS.CHANGE_EMAIL_FORM_LOAN_NUMBER_LABEL]: 'Account number',
  [IDS.CHANGE_EMAIL_STEP_ONE_FORM_HEADING]: 'To update your email address, verify your account information first',
  [IDS.CHANGE_EMAIL_STEP_ONE_FORM_PARAGRAPH]: 'Your 10-digit account number can be found on Murabaha Financing Transaction statements and other Murabaha Financing Transaction-related documents.',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
